import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function WikiLogin() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [credentials, setCredentials] = useState({
    username: "",
    password: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(`${API}/wiki/login`, credentials);
      
      if (response.data.success) {
        localStorage.setItem("wiki_token", response.data.token);
        localStorage.setItem("wiki_username", response.data.username);
        toast.success("Login successful!");
        navigate("/wiki");
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Invalid username or password");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f6f6f6]">
      {/* Wikipedia-style header */}
      <div className="bg-white border-b border-[#a7d7f9]">
        <div className="max-w-[1200px] mx-auto px-4 py-2 flex items-center gap-4">
          <Link to="/wiki" className="flex items-center gap-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_df6f992c-82a6-44fb-a88f-450c0ac99b5b/artifacts/cvze4lab_q2y0upqj_75c9mfk0_Square%20Logo%20%28100%20x%20100%29.png" 
              alt="Ethical Wiki" 
              className="w-10 h-10"
            />
            <span className="font-wiki text-xl text-[#202122]">Ethical Wiki</span>
          </Link>
        </div>
      </div>

      {/* Login Form */}
      <div className="max-w-[400px] mx-auto mt-12 px-4">
        <div className="bg-white border border-[#a2a9b1] p-6">
          <h1 className="font-wiki text-2xl text-[#202122] mb-6 border-b border-[#a2a9b1] pb-3">
            Log in
          </h1>
          
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="username" className="block text-sm text-[#202122] mb-1">
                Username
              </label>
              <input
                type="text"
                id="username"
                name="username"
                value={credentials.username}
                onChange={handleChange}
                className="w-full border border-[#a2a9b1] px-3 py-2 text-sm focus:border-[#3366cc] focus:outline-none"
                required
                data-testid="wiki-username-input"
              />
            </div>
            
            <div className="mb-6">
              <label htmlFor="password" className="block text-sm text-[#202122] mb-1">
                Password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={credentials.password}
                onChange={handleChange}
                className="w-full border border-[#a2a9b1] px-3 py-2 text-sm focus:border-[#3366cc] focus:outline-none"
                required
                data-testid="wiki-password-input"
              />
            </div>
            
            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-[#3366cc] text-white py-2 px-4 text-sm font-medium hover:bg-[#2a4b8d] disabled:opacity-50"
              data-testid="wiki-login-btn"
            >
              {isLoading ? "Logging in..." : "Log in"}
            </button>
          </form>
          
          <p className="mt-4 text-xs text-[#72777d] text-center">
            Access is restricted to authorized administrators only.
          </p>
        </div>
      </div>
    </div>
  );
}
